import { render, staticRenderFns } from "./ReplyChat.vue?vue&type=template&id=278c3281&scoped=true&"
import script from "./ReplyChat.vue?vue&type=script&lang=js&"
export * from "./ReplyChat.vue?vue&type=script&lang=js&"
import style0 from "./ReplyChat.vue?vue&type=style&index=0&id=278c3281&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278c3281",
  null
  
)

export default component.exports